// src/services/percentage.ts
function percentage(numerator, denominator) {
  return safeDivision(numerator, denominator) * 100;
}

// src/services/percentage-of.ts
function percentageOf(value, percent) {
  return value * percent / 100;
}

// src/services/safe-division.ts
function safeDivision(numerator, denominator) {
  return denominator === 0 ? 0 : numerator / denominator;
}

// src/services/parse-number.ts
function parseNumber(value) {
  const parsedNumber = Number(value);
  return isNaN(parsedNumber) ? void 0 : parsedNumber;
}

// src/services/round-to.ts
import { notDefined } from "@vy/null";
var CURRENCY_PRECISION = 2;
function roundTo(value, precision) {
  if (notDefined(precision)) {
    return value;
  }
  const factor = Math.pow(10, precision);
  return Math.round(value * factor) / factor;
}

// src/services/format-number.ts
var MAXIMUM_FRACTION_DIGITS = 2;
var MINIMUM_SIGNIFICANT_DIGITS = 1;
var DEFAULT_MINIMUM_FRACTION_DIGITS = 2;
function formatNumber(num, maximumFractionDigits = MAXIMUM_FRACTION_DIGITS, options, formatMillions = false) {
  const numValue = num ?? 0;
  if (formatMillions && numValue >= 1e6) {
    const millions = Math.round(numValue / 1e6);
    return `${millions}M`;
  }
  const minimumFractionDigits = getMinimumFractionDigits(numValue);
  const cappedMinimumFractionDigits = Math.min(minimumFractionDigits, maximumFractionDigits);
  return numValue.toLocaleString("en-US", {
    style: "decimal",
    minimumFractionDigits: cappedMinimumFractionDigits,
    maximumFractionDigits,
    ...options
  });
}
function getMinimumFractionDigits(number) {
  if (Number.isInteger(number)) {
    return 0;
  }
  const fractionalPart = number.toString().split(".")[1];
  const startingZeroesCount = Array.from(fractionalPart).findIndex((digit) => digit !== "0");
  return Math.max(startingZeroesCount + MINIMUM_SIGNIFICANT_DIGITS, DEFAULT_MINIMUM_FRACTION_DIGITS);
}

// src/services/when-nan.ts
import { isFunction } from "@vy/function";

// src/services/is-nan.ts
function isNaN2(value) {
  return Number.isNaN(value);
}

// src/services/when-nan.ts
function whenNaN(value, operationOnValue) {
  if (!isFunction(operationOnValue)) {
    return whenNaN(value, () => operationOnValue);
  }
  return isNaN2(value) ? operationOnValue() : value;
}

// src/services/is-number.ts
function isNumber(value) {
  return typeof value === "number" && !isNaN2(value);
}

// src/services/is-positive.ts
function isPositive(value) {
  return value != null && value > 0;
}

// src/services/sum-by.ts
function sumBy(items, accessor) {
  return items.reduce((total, item) => total + accessor(item), 0);
}

// src/services/is-zero-amount.ts
var PRICE_ZERO_THRESHOLD = Math.pow(10, -6);
function isZeroAmount(amount) {
  return amount >= 0 && amount <= PRICE_ZERO_THRESHOLD;
}
export {
  CURRENCY_PRECISION,
  PRICE_ZERO_THRESHOLD,
  formatNumber,
  isNaN2 as isNaN,
  isNumber,
  isPositive,
  isZeroAmount,
  parseNumber,
  percentage,
  percentageOf,
  roundTo,
  safeDivision,
  sumBy,
  whenNaN
};
